import React from "react";

import "./style.scss"
import uris from "../../config/uris";
import OrgSection from "./org-section";
import UserSection from "./user-section";
import Breadcrumbs from "../../assets/component/breadcrumbs";
import TeamSection from "./team-section";

const OrganizationSetting = () => {
    const menuData = {
        title: "Organization Settings",
        parentMenu: {
            name: "Organization Settings",
            link: uris.organizationSettings
        },
    }

    return (
        <>
            <div className="organization-page-main">
                <div className="header">
                    <Breadcrumbs breadcrumbDetails={menuData} />
                </div>
                <div className="organization-page-main-container">
                    <OrgSection />
                    <UserSection />
                    <TeamSection />
                </div>
            </div>
        </>
    )
}

export default OrganizationSetting;